var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.inmobiliaria)?_c('Inmobiliaria'):_vm._e(),(_vm.soc)?_c('Soc',{attrs:{"guid":_vm.guid}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }